import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import axios from "axios"
import Filter from "./../common/js/filter"
import ElementUI from "element-ui"
import locale from 'element-ui/lib/locale/lang/zh-TW'
import Driver from "driver.js";
import "driver.js/dist/driver.min.css";
import "./../common/css/common.css"
import "element-ui/lib/theme-chalk/index.css"
import Pagination from "@/components/Pagination"
import Draggable from "vuedraggable";
import VueCropper from 'vue-cropper'
import Qrcode from 'vue_qrcodes'
import $ from 'jquery'
// 引入公共js
import pub from "./../common/public"
// 引入自动更新提醒
import autoUpdate from './auto-update'
// 非生产环境使用
// process.env.VUE_APP_TYPE == 'prd' && autoUpdate.start()
if (process.env.VUE_APP_TYPE === 'prd') {
  autoUpdate.start();
}
// import echarts from 'echarts';
// Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false
Vue.use(ElementUI, {
  locale
}).use(Filter)
Vue.use(VueCropper)
Vue.component("Pagination", Pagination) //分页组件
Vue.component("Draggable", Draggable) //可拖拽组件
Vue.component("Qrcode", Qrcode) //分页组件
// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    config.params = config.params || {}
    config.params.cityen = "hk"
    config.params.platform = config.params.platform || "pc"
    config.params.pmsver = "20260605"
    // config.params.pmsver = new Date().toISOString().slice(0, 10).replace(/-/g, "")
    config.params.language = "zh-hk"
    config.params.token = window.token || pub.getCookie("dEVaUDFrZ1kd0RA")
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)


  /**图片错误拦截器 */
  window.errorImg = function (img, type) {
    if (type === 'agent' || type === 'user') {
      img.src = '//static.house730.com/m/images/staff-default.png';
    } else {
      img.src = '//static.house730.com/m/images/house-bg.png';
    }
    // 防止onerror事件死循环,同一个标签加载10次后置空
    let count = img.getAttribute('count');
    count = count ? ++count : 1;
    img.setAttribute('count', count);
    // count > 10 ? (img.onerror = null) : '';
    if (count > 10) {
      img.onerror = null;
    }
  };
// 添加token失效拦截器
axios.interceptors.response.use(
  function (response) {
    if (response.data.code === 100) {
      pub.delCookie('dEVaUDFrZ1kd0RA');
      if (location.href.indexOf("login") == -1 && location.href.indexOf("appdown") == -1) {router.replace({
        path: '/login',
        // query: {
        //   referrer: router.currentRoute.fullPath
        // } // 到登录页重新获取token
      });}
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 引入
Vue.prototype.axios = axios
Vue.prototype.pub = pub
Vue.prototype.Driver = Driver
Vue.prototype.$ = $
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
